<header>
  <div class="header-toolbar">
    <div class="responsive-row">
      <div>
        <h1 class="header-toolbar__heading">
          <strong class="header-toolbar__heading--bold">{{ 'menu.title.part1' | translate }}</strong>
          <span>&nbsp;{{ 'menu.title.part2' | translate }}</span>
        </h1>
        @if (isAuthenticated | async) {
          <span class="header-toolbar__user-info">
            {{ 'label.personalNumber' | translate }} {{ personalNumber() }}
          </span>
        }
      </div>
      <portal-logo-svg
        [altText]="'header.logo.alternative_text' | translate"
        className="header-toolbar__customer-logo" />
    </div>
  </div>
  <portal-navigation />
</header>
